import React, { Fragment } from 'react';
import { bool } from 'prop-types';
import { styWrapper } from '../HelloSection/styles';

function TurutMengundang() {
  return (
    <Fragment>
      <div id="fh5co-couple" className="fh5co-section-gray" css={styWrapper}>
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
                <h2 className="main-font">Turut Mengundang</h2>
                <p className="info">
                Bpk. H. Kurniawan S.Sos, M.Si (Kades Tarikolot)<br/>
                Bpk. H. Ust miptah (Tokoh Agama)<br/>
                Bpk. Ust Usman (Tokoh Agama)<br/>
                Bpk. NurulIman (Ket. RT 001)<br/>
                Bpk. Oob (Ket. RW 002)<br/>
                Kel. Besar Bpk. Syahroni Cilacap<br/>
                Bpk. Jajang (Uwa)<br/>
                Bpk. Pepen (Uwa)<br/>
                Bpk. Azis (Uwa)<br/>
                Ibu Azizah (Bibi)<br/>
                Jejen (Paman)<br/>
                Endi / Jener (Paman)<br/>
                Keluarga SKWN<br/>
                Keluarga WBS<br/>
                Keluarga Ardes<br/>
                Kel. Besar PT. Famindo Roda Gemilang Manufaktur
                </p>
              </div>
            </div>
          </div>
        </div>
    </Fragment>
  );
}

export default React.memo(TurutMengundang);
